import styled from 'styled-components';
import {Tag} from 'antd';
import Card from '../../../../Card';
import {typographyStyles} from '../../../../../utils/styles';

const StyledTagManager = styled(Card)`
  .ant-card-head {
    padding: 0 24px;
  }

  .ant-card-body {
    & > p {
      color: ${props => props.theme.colors.neutral_8};
    }

    input {
      font-size: 14px;
    }
  }
`;

const StyledTag = styled(Tag)`
  ${typographyStyles.body.regular};
  line-height: 20px;
  font-family: 'Outfit', sans-serif;
  margin-top: 8px;
  padding: 6px 8px;

  &.disabled {
    cursor: unset;
    opacity: 0.4;
    pointer-events: none;
  }
`;

export {StyledTagManager, StyledTag};
